import React, { useState } from "react";
import Modal from "react-modal";

const CustomModal = ({
  isModalVisible = false,
  onRequestClose,
  children,
  title = "User Levels",
}) => {
  return (
    <div className="flex justify-center items-center w-full">
      <Modal
        isOpen={isModalVisible}
        onRequestClose={onRequestClose}
        style={{
          content: {
            display: "flex",
            justifyContent: "center",
            // alignItems: 'center',
            borderRadius: "1rem",
            background: "#fff",
            padding: "2rem",
            // margin: "8rem 20rem",
            // height: '100%'
            // width: '40%'
          },
          overlay: {
            background: "#000000 0% 0% no-repeat padding-box",
            zIndex: 1,
          },
        }}
      >
        {/* <div className="text-[2rem] text-[red] absolute top-[-4.5rem] right-[0px]">
          Close <span className="text-[2.9rem]">[x]</span>
        </div> */}
        <div className="w-full">
          {/* Header */}
            <div className="flex justify-between">
              <div>
                <div className="text-[1.1rem] text-[#797979]">{title}</div>
              </div>
              <div
                className="text-2xl text-red cursor-pointer mr-2"
                onClick={onRequestClose}
              >
                x
              </div>
            </div>
          {/* Body */}
            <div>
              Hello Body
              {children}
            </div>
          {/* Footer */}
            <div>
              Hello Footer
            </div>
        </div>
      </Modal>
    </div>
  );
};

export default CustomModal;
